import { useState, useEffect } from 'react';
import { ProjectContent } from '../services/types';

export const useProjectContent = () => {
    const [content, setContent] = useState<null | ProjectContent[]>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch('https://retoolapi.dev/s5Iapd/projects');
                if (!response.ok) {
                    throw new Error(`Failed to fetch content: ${response.statusText}`);
                }

                const result = await response.json();
                setContent(result);
            } catch (err) {
                if (err instanceof Error) {
                    setError(err.message);
                } else {
                    setError('An unknown error occurred');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { content, loading, error };
};
